
$(document).ready(() => {
    $(".fancybox-open").on('click', function(e) {
        e.preventDefault();
        var imageIndex = $(this).data('fancybox-index');
        $.fancybox.open( $('.image-gallery--item'), {
            touch: false,
            infobar: false,
            index: imageIndex,
            loop: true,
        });
    });
});
